export const TwitterIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_67_2735)">
      <path
        d="M23.9632 2.34719C23.9525 2.19049 23.8959 2.0404 23.8005 1.91563C23.7051 1.79087 23.5751 1.69696 23.4266 1.6456C23.2782 1.59424 23.1179 1.58772 22.9658 1.62684C22.8137 1.66596 22.6764 1.749 22.5712 1.86559C22.0481 2.4524 21.3671 2.87621 20.6096 3.08639C19.5881 2.13011 18.2409 1.59864 16.8416 1.59999C16.098 1.60041 15.3618 1.74729 14.6749 2.03224C13.9881 2.31719 13.3641 2.73463 12.8386 3.26073C12.3131 3.78683 11.8964 4.41129 11.6122 5.09844C11.328 5.7856 11.182 6.522 11.1824 7.26559V7.96959C6.3968 7.59999 3.84 3.96319 3.1472 2.11999C3.09267 1.97392 2.99664 1.84698 2.87093 1.75475C2.74521 1.66253 2.59529 1.60905 2.43959 1.60089C2.28389 1.59273 2.1292 1.63025 1.99453 1.70883C1.85987 1.78741 1.7511 1.90362 1.6816 2.04319C0.00639992 5.39679 -0.2512 8.65119 0.9664 11.4224C2.032 13.8496 4.176 15.7824 7.216 17.064C5.8352 18.0416 3.5104 19.2 0.8 19.2C0.628223 19.1998 0.46094 19.2549 0.322897 19.3571C0.184855 19.4593 0.083385 19.6033 0.0334986 19.7677C-0.0163878 19.932 -0.0120413 20.1081 0.0458953 20.2698C0.103832 20.4315 0.212281 20.5703 0.3552 20.6656C2.9552 22.4 5.68 22.4 8.2112 22.4H8.288C16.0656 22.4 22.368 16.0864 22.368 8.30079V7.53439C22.9488 6.94239 23.4016 6.33919 23.68 5.55679C23.9888 4.68319 24.0512 3.67199 23.9632 2.34719Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_67_2735">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhatsAppIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C5.3724 0 0 5.3724 0 12C0 14.268 0.63 16.392 1.7256 18.2016L0.6552 21.84C0.593741 22.0489 0.589697 22.2705 0.643493 22.4815C0.697289 22.6925 0.806937 22.8851 0.960911 23.0391C1.11488 23.1931 1.3075 23.3027 1.5185 23.3565C1.7295 23.4103 1.9511 23.4062 2.16 23.3448L5.7984 22.2744C7.66881 23.4061 9.81386 24.003 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0ZM9.2856 14.7156C11.7132 17.142 14.0304 17.4624 14.8488 17.4924C16.0932 17.538 17.3052 16.5876 17.7768 15.4848C17.8363 15.3476 17.8579 15.1969 17.8394 15.0486C17.8208 14.9002 17.7627 14.7595 17.6712 14.6412C17.0136 13.8012 16.1244 13.1976 15.2556 12.5976C15.0742 12.4722 14.8513 12.4219 14.6336 12.4572C14.4159 12.4926 14.2204 12.6108 14.088 12.7872L13.368 13.8852C13.3301 13.9442 13.2712 13.9865 13.2031 14.0035C13.1351 14.0205 13.0631 14.0108 13.002 13.9764C12.5136 13.6968 11.802 13.2216 11.2908 12.7104C10.7796 12.1992 10.3332 11.52 10.0824 11.0628C10.0513 11.0047 10.0423 10.9373 10.0571 10.8731C10.0719 10.8089 10.1094 10.7522 10.1628 10.7136L11.2716 9.8904C11.4298 9.75281 11.532 9.56183 11.5585 9.35383C11.5851 9.14583 11.5342 8.93532 11.4156 8.7624C10.878 7.9752 10.2516 6.9744 9.3432 6.3108C9.22596 6.22584 9.08863 6.17287 8.94472 6.15709C8.8008 6.14131 8.65525 6.16326 8.5224 6.2208C7.4184 6.6936 6.4632 7.9056 6.5088 9.1524C6.5388 9.9708 6.8592 12.288 9.2856 14.7156Z"
      fill="currentColor"
    />
  </svg>
);

export const CaptainIcon = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1178_5253)">
      <circle cx="8.5" cy="8" r="8" fill="currentColor" />
      <path
        d="M9.12498 5.61963C8.51734 5.61963 8.04685 5.8488 7.71352 6.30713C7.38019 6.76199 7.21352 7.39741 7.21352 8.21338C7.21352 9.9113 7.85067 10.7603 9.12498 10.7603C9.6597 10.7603 10.3073 10.6266 11.0677 10.3592V11.7134C10.4427 11.9738 9.74477 12.104 8.97394 12.104C7.8663 12.104 7.01908 11.7689 6.43227 11.0988C5.84547 10.4252 5.55206 9.45991 5.55206 8.20296C5.55206 7.4113 5.69616 6.71859 5.98435 6.12484C6.27255 5.52762 6.68574 5.07102 7.22394 4.75505C7.7656 4.4356 8.39929 4.27588 9.12498 4.27588C9.86456 4.27588 10.6076 4.4547 11.3541 4.81234L10.8333 6.12484C10.5486 5.98942 10.2621 5.87137 9.97394 5.77067C9.68574 5.66998 9.40276 5.61963 9.12498 5.61963Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1178_5253">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ViceCaptainIcon = (props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1178_4348)">
      <circle cx="8.5" cy="8" r="8" fill="currentColor" />
      <path
        d="M10.3333 4.38525H11.9635L9.375 11.9998H7.61458L5.03125 4.38525H6.66146L8.09375 8.9165C8.17361 9.18387 8.25521 9.49637 8.33854 9.854C8.42535 10.2082 8.47917 10.4547 8.5 10.5936C8.53819 10.2741 8.6684 9.71512 8.89063 8.9165L10.3333 4.38525Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1178_4348">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
